<template>
  <div>

    <div v-if="user.referrer_name">
      <h3>Referred By: <v-chip close @input="removeReferrer">{{ user.referrer_name }} on {{ user.referred_at | moment('MMMM DD, YYYY') }}</v-chip></h3>
    </div>

    <div v-else>
      <v-btn @click="toggleReferManage">
        <v-icon left>
          add
        </v-icon>
        Add Referral
      </v-btn>
      <form v-if="manageRefer">
        <v-select
          :items="referrers"
          item-text="name"
          item-value="id"
          v-model="selectedReferrerID"
          label="Referrers"
        />
        <div v-if="addingNew">
          <v-text-field
            v-model="newReferrerName"
            label="New Referrer Name"
          />
          <v-btn
            @click="addReferrer"
            color="success"
          >Save New Referrer</v-btn>
        </div>
        <v-btn
          v-if="selectedReferrerID && selectedReferrerID > 0"
          :disabled="saving"
          :loading="saving"
          @click="saveReferrer"
          color="success"
        >Save Referral</v-btn>
      </form>
    </div>
  </div>
</template>

<script>

export default {
  props: [
    'user'
  ],

  data() {
    return {
      manageRefer: false,
      selectedReferrerID: '',
      saving: false,
      addingNew: false,
      newReferrerName: '',
    }
  },

  watch: {
    selectedReferrerID(val) {
      if (val === -1) {
        this.addingNew = true
      } else {
        this.addingNew = false
      }
    },
  },

  computed: {
    referrers() {
      return this.$store.state.referrers.referrers
        .concat({
          id: -1,
          name: 'Add New...'
        })
    }
  },

  created() {
    this.getReferrers()
  },

  methods: {
    toggleReferManage() {
      this.manageRefer = !this.manageRefer
    },

    saveReferrer() {
      if (this.user.role === 'client') {
        var call = this.$store.dispatch('clients/update', {
          id: this.user.id,
          referrer_id: this.selectedReferrerID,
        })
      } else if (this.user.role = 'employee') {
        var call = this.$store.dispatch('employees/update', {
          employee: {
            id: this.user.id,
            referrer_id: this.selectedReferrerID,
          }
        })
      }

      this.saving = true
      call
        .then(res => {
          this.$store.dispatch('global/showSnackbarSuccess', { message: 'Referral saved!' })
        })
        .catch(error => {
          console.log(error)
          this.$store.dispatch('global/showSnackbarError', { message: 'Something went wrong saving that referral...' })
        })
        .finally(() => {
          this.saving = false
          this.manageRefer = false
        })
    },

    removeReferrer() {
      if (this.user.role === 'client') {
        var call = this.$store.dispatch('clients/update', {
          id: this.user.id,
          referrer_id: null,
        })
      } else if (this.user.role = 'employee') {
        var call = this.$store.dispatch('employees/update', {
          employee: {
            id: this.user.id,
            referrer_id: null,
          }
        })
      }
      call
        .then(res => {
          this.$store.dispatch('global/showSnackbarSuccess', { message: 'Referral removed!' })
        })
        .catch(error => {
          this.$store.dispatch('global/showSnackbarError', { message: 'Something went wrong removing that referral...' })
        })
        .finally(() => {
          this.saving = false
          this.manageRefer = false
        })
    },

    getReferrers() {
      this.$store.dispatch('referrers/getReferrers')
    },

    addReferrer() {
      this.$store.dispatch('referrers/createReferrer', { name: this.newReferrerName })
      .then((r) => {
        if (this.user.role === 'client') {
          var call = this.$store.dispatch('clients/update', {
            id: this.user.id,
            referrer_id: r.id,
          })
        } else if (this.user.role = 'employee') {
          var call = this.$store.dispatch('employees/update', {
            employee: {
              id: this.user.id,
              referrer_id: r.id,
            }
          })
        }
        call
          .then(r => {
            this.$store.dispatch('global/showSnackbarSuccess', { message: 'Referral saved!' })
          }).catch((e) => {
            this.$store.dispatch('global/showSnackbarSuccess', { message: 'Error saving referral' })
          })
      })
      .catch((e) => {
        this.$store.dispatch('global/showSnackbarError', { message: `Could not save referrer: ${ e.response.data.join(", ") }` })
      })
      .finally(() => {
        this.newReferrerName = ''
        this.addingNew = false
      })
      // close addingNew after
    },

  }
}
</script>
